export default __webpack_public_path__ + "static/media/download-close.dcc1850e.svg";